import { createSlice } from "@reduxjs/toolkit";
import { createThunkCases } from "./slice";
import { GetQuestionsByCategoryThunk } from "./thunk";

const initialState = {
  previousCategoryLength: null,
  categories: [],
  questions: [],
  content: "",
  loader: false,
  error: null,
  showPopup: false,
};

const editorSlice = createSlice({
  name: "PaperEditorSlice",
  initialState,
  reducers: {
    handleCheckBox(state, action) {
      const { type, data } = action.payload;

      if (type) {
        state.questions.push(data);
      } else {
        state.questions = state.questions.filter(
          (q) => q.question_id !== data.question_id
        );
      }

      const exists = state.categories.some(
        (q) => q.type_id === data.question_typeid
      );

      if (!exists) {
        const validOrderIds = state.categories
          .map((c) => c.orderId)
          .filter((id) => typeof id === "number" && !isNaN(id));

        const otherData = data.question_id === "header" ? data : null;

        const nextOrderId =
          validOrderIds.length > 0 ? Math.max(...validOrderIds) + 1 : 1;

        state.categories.push({
          orderId: nextOrderId,
          type_name: data.type_name,
          type_id: data.question_typeid,
          display: true,
          marks: "",
          questions: "",
          otherData,
        });
      }
    },

    handleQuestionMarks(state, action) {
      const { id, marks } = action.payload;
      state.questions = state.questions.map((q) =>
        q.question_id === id ? { ...q, marks } : { ...q }
      );
    },
    addQuestion: (state, action) => {
      state.questions = [...state.questions, action.payload];
    },
    clearQuestions(state) {
      state.questions = [];
    },
    showLoginPopup(state, action) {
      state.showPopup = action.payload;
    },

    handleCategories(state, action) {
      const { data, value } = action.payload;

      if (value) {
        const exists = state.categories.some((q) => q.type_id === data.id);

        if (!exists) {
          const validOrderIds = state.categories
            .map((c) => c.orderId)
            .filter((id) => typeof id === "number" && !isNaN(id));

          const nextOrderId =
            validOrderIds.length > 0 ? Math.max(...validOrderIds) + 1 : 1;

          state.categories.push({
            orderId: nextOrderId,
            type_name: data.name,
            type_id: data.id,
            type_title: data.title,
            display: true,
            marks: "",
            questions: "",
          });
          state.previousCategoryLength = state.categories.length - 1;
        }
      } else {
        state.categories = state.categories.filter(
          (category) => category.type_id !== data.id
        );
      }
    },

    updateCategories(state, action) {
      state.categories = state.categories.map((c) => {
        if (c.type_id === action.payload.type_id) {
          return action.payload;
        } else {
          return c;
        }
      });
    },

    handleEditorContent(state, action) {
      state.content = action.payload;
    },

    handleHeaderContent(state, action) {
      const { category, question } = action.payload;
      state.categories.push(category);
      state.questions.push(question);
    },

    moveCategory(state, action) {
      // 1 - up
      // 2 - down

      const { categoryTypeId, type } = action.payload;
      const sorted = [...state.categories].sort(
        (a, b) => a.orderId - b.orderId
      );
      const index = sorted.findIndex((c) => c.type_id === categoryTypeId);

      if (type === 1 && index > 0) {
        const temp = sorted[index - 1].orderId;
        sorted[index - 1].orderId = sorted[index].orderId;
        sorted[index].orderId = temp;
      }

      if (type === 2 && index < sorted.length - 1) {
        const temp = sorted[index + 1].orderId;
        sorted[index + 1].orderId = sorted[index].orderId;
        sorted[index].orderId = temp;
      }

      state.categories = sorted;
    },

    resetData(state, action) {
      state.categories = [];
      state.questions = [];
    },

    prefillData(state, action) {
      const { questions, categories } = action.payload;
      state.questions = [...questions];
      state.categories = [...categories];
    },
  },
  extraReducers(builder) {
    createThunkCases(
      builder,
      GetQuestionsByCategoryThunk,
      null,
      "Error Getting Category Questions",
      (state, action) => {
        const categoryId = action.meta.arg.categoryId;
        state.categories = state.categories.map((category) =>
          category.type_id === categoryId
            ? {
                ...category,
                catQstns: [...action.payload],
                questionsPanel: true,
              }
            : category
        );
      }
    );
  },
});

export const {
  handleCheckBox,
  handleEditorContent,
  handleHeaderContent,
  updateCategories,
  handleQuestionMarks,
  moveCategory,
  resetData,
  handleCategories,
  prefillData,
  addQuestion,
  clearQuestions,
  showLoginPopup,
} = editorSlice.actions;
export default editorSlice.reducer;
